/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApiError,
  GenerateShareCopyResponse,
  PostGenerateShareCopyBody,
} from '../models/index';
import {
    ApiErrorFromJSON,
    ApiErrorToJSON,
    GenerateShareCopyResponseFromJSON,
    GenerateShareCopyResponseToJSON,
    PostGenerateShareCopyBodyFromJSON,
    PostGenerateShareCopyBodyToJSON,
} from '../models/index';

export interface CreateGenerateShareCopyRequest {
    postGenerateShareCopyBody: PostGenerateShareCopyBody;
}

/**
 * ShareApi - interface
 * 
 * @export
 * @interface ShareApiInterface
 */
export interface ShareApiInterface {
    /**
     * Calls Claude (Haiku) with a small system prompt + per-type context. Falls back to a static template when ANTHROPIC_API_KEY is missing or the model call throws — never returns an empty string. 
     * @summary Generate AI-suggested social share copy
     * @param {PostGenerateShareCopyBody} postGenerateShareCopyBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShareApiInterface
     */
    createGenerateShareCopyRaw(requestParameters: CreateGenerateShareCopyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GenerateShareCopyResponse>>;

    /**
     * Calls Claude (Haiku) with a small system prompt + per-type context. Falls back to a static template when ANTHROPIC_API_KEY is missing or the model call throws — never returns an empty string. 
     * Generate AI-suggested social share copy
     */
    createGenerateShareCopy(requestParameters: CreateGenerateShareCopyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GenerateShareCopyResponse>;

}

/**
 * 
 */
export class ShareApi extends runtime.BaseAPI implements ShareApiInterface {

    /**
     * Calls Claude (Haiku) with a small system prompt + per-type context. Falls back to a static template when ANTHROPIC_API_KEY is missing or the model call throws — never returns an empty string. 
     * Generate AI-suggested social share copy
     */
    async createGenerateShareCopyRaw(requestParameters: CreateGenerateShareCopyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GenerateShareCopyResponse>> {
        if (requestParameters['postGenerateShareCopyBody'] == null) {
            throw new runtime.RequiredError(
                'postGenerateShareCopyBody',
                'Required parameter "postGenerateShareCopyBody" was null or undefined when calling createGenerateShareCopy().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/generate-share-copy`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PostGenerateShareCopyBodyToJSON(requestParameters['postGenerateShareCopyBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GenerateShareCopyResponseFromJSON(jsonValue));
    }

    /**
     * Calls Claude (Haiku) with a small system prompt + per-type context. Falls back to a static template when ANTHROPIC_API_KEY is missing or the model call throws — never returns an empty string. 
     * Generate AI-suggested social share copy
     */
    async createGenerateShareCopy(requestParameters: CreateGenerateShareCopyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GenerateShareCopyResponse> {
        const response = await this.createGenerateShareCopyRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
